export default "__VITE_ASSET__D7yGOGp0__"